const SPECIFIC_PARTNERS_IDS = {
  quantumsoft: 107,
  vacation: 105,
};

export default SPECIFIC_PARTNERS_IDS;
